export default {
  line: {
    fill: 'none',
    stroke: ({ color }) => color,
    strokeWidth: 3,
  },
};
